<div class="row h-100">
    <div class="col-md-5 col-lg-5 col-xl-5 p-0 h-100" [ngClass]="showSpinner ? 'blur-class' : ''">
        <div class="ml-3 h-100 border-primary">
            <nav class="navbar navbar-expand-lg">
                <div class="collapse navbar-collapse">
                    உள்ளீடு
                    <ul class="navbar-nav ml-auto font-weight-bold mx-1">
                        <li class="nav-item mx-2 image-upload cursor-pointer" data-toggle="tooltip"
                            title="கோப்பை இறக்குமதி செய்க">
                            <label for="file-input"> <svg class="bi bi-folder img " width="1.5em" height="1.5em"
                                    viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.828 4a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 6.173 2H2.5a1 1 0 0 0-1 .981L1.546 4h-1L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3v1z" />
                                    <path fill-rule="evenodd"
                                        d="M13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zM2.19 3A2 2 0 0 0 .198 5.181l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H2.19z" />
                                </svg></label>

                            <input id="file-input" (change)="onChange($event.target.files)" accept="text/plain,doc,docx"
                                type="file" />

                        </li>
                        <li class="nav-item mx-2 cursor-pointer" (click)="inputEditorClearText()" data-toggle="tooltip"
                            title="உரையை அகற்று"><svg xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-clear-all" width="24" height="24"
                                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M8 6h12" />
                                <path d="M6 12h12" />
                                <path d="M4 18h12" />
                            </svg>
                        </li>
                    </ul>
                </div>


            </nav>
            <div class="h-100 input-group">
                <div class="input-group-prepend">
                    <textarea class="form-control linenumber" nowrap="nowrap" wrap="off" cols="3" readonly="readonly"
                        (scroll)="updateScrolledditor1()" #inputEditorLinenumber></textarea>
                </div>
                <textarea [(ngModel)]="importContent" class="form-control texteditor white-space" rows="2"
                    (scroll)="updateScrolledditor1()" #inputEditor></textarea>
            </div>
        </div>
    </div>
    <div class="h-100 col-md-2 col-lg-2 col-xl-2" *ngIf="!showSpinner">
        <div class="h-100 align-middle">
            <button type="button" class="btn btn-light btn-lg btn-block button-bg-color"
                (click)="indexing()">சொல்லடைவு</button>
            <button type="button" class="btn btn-light btn-lg btn-block" (click)="concordanceWord()">தொடரடைவு</button>
            <button type="button" class="btn btn-light btn-lg btn-block" (click)="OnClickExtract()">பிரித்தெடு</button>
            <button type="button" class="btn btn-light btn-lg btn-block"
                (click)="wordSorting('accending' , true)">வரிசைப்படுத்து</button>
            <input class="form-control mr-sm-2 search-bg-color" style="position: relative; top: 43px;" type="text"
                placeholder="உள்ளீட்டு" [(ngModel)]="query_conversation" />
            <button type="button" class="btn btn-light btn-lg btn-block" style="position: relative; top: 47px;"
                (click)="onClickSearch()">தேடல்</button>
        </div>
    </div>
    <div class="h-100 col-md-2 col-lg-2 col-xl-2" *ngIf="showSpinner">
        <div class="align-middle">
            <img src="assets/spinner.gif" style="display:block; margin-left: 40%; margin-top: 100%; width: 30%;" />
        </div>
    </div>
    <div class="col-md-5 col-lg-5 col-xl-5 p-0 h-100" [ngClass]="showSpinner ? 'blur-class' : ''">
        <div class="mr-3 h-100 border-primary">
            <nav class="navbar navbar-expand-lg">
                <div class="collapse navbar-collapse">
                    வெளியீடு
                    <ul class="navbar-nav ml-auto font-weight-bold mx-1">
                        <button type="button" class="btn btn-light btn-lg btn-block"
                            style="position: relative; background: #6f969b; padding-top: 2px; padding-bottom: 2px; border: none; box-shadow: none; color: white; font-size: 0.9rem;"
                            (click)="copyInputMessage()">
                            நகலெடு</button>
                        <div class="nav-item mx-2 cursor-pointer" (click)="wordSorting('desending')"
                            data-toggle="tooltip" title="ஏறுவரிசை"><svg xmlns="http://www.w3.org/2000/svg" width="25"
                                height="25" fill="currentColor" class="bi bi-sort-up" viewBox="0 0 16 16"
                                id="IconChangeColor">
                                <path
                                    d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                                    id="mainIconPathAttribute"></path>
                            </svg></div>
                        <div class="nav-item mx-2 cursor-pointer" (click)="wordSorting('accending')"
                            data-toggle="tooltip" title="இறங்கு வரிசை"><svg xmlns="http://www.w3.org/2000/svg"
                                width="25" height="25" fill="currentColor" class="bi bi-sort-down" viewBox="0 0 16 16"
                                id="IconChangeColor">
                                <path
                                    d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                                    id="mainIconPathAttribute" filter="url(#shadow)"></path>
                                <filter id="shadow">
                                    <feDropShadow id="shadowValue" stdDeviation=".5" dx="0" dy="0" flood-color="black">
                                    </feDropShadow>
                                </filter>
                                <filter id="shadow">
                                    <feDropShadow id="shadowValue" stdDeviation=".5" dx="0" dy="0" flood-color="black">
                                    </feDropShadow>
                                </filter>
                            </svg></div>
                        <li class="nav-item mx-2 cursor-pointer" (click)="outputEditorClearText()" data-toggle="tooltip"
                            title="உரையை அகற்று"><svg xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-clear-all" width="24" height="24"
                                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M8 6h12" />
                                <path d="M6 12h12" />
                                <path d="M4 18h12" />
                            </svg>
                        </li>

                    </ul>
                </div>
            </nav>
            <div class="h-100 input-group">
                <div class="input-group-prepend">
                    <textarea class="form-control linenumber" cols="3" readonly="readonly"
                        #outputEditorLinenumber></textarea>
                </div>
                <div appHighlight [value]="value" [content]="content" [searchTerm]="searchValue" [caseSensitive]="false"
                    class="form-control texteditor white-space" rows="2" #outputEditor>
                    {{content}}</div>
            </div>
        </div>
    </div>
</div>